<h1 mat-dialog-title>{{'executionEdit.test.observation.title' | translate}}</h1>
<form>
    <div mat-dialog-content class="qualificates-theme">

        <div fxLayout="row" class="flexwrap">

            <div fxFlex="10" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'executionEdit.test.observations.position.label' | translate }}</mat-label>
                    <input matInput
                        name="position" [(ngModel)]="data.data.position" required [disabled]="true">
                </mat-form-field>
            </div>

            <div fxFlex="90" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario" style="width: 100%">
                    <mat-label>{{ 'executionEdit.test.observations.description.label' | translate }}</mat-label>
                    <textarea rows="5" matAutosizeMinRows="5" matInput 
                        [(ngModel)]="data.data.description" required
                        name="observations" style="resize: none;">
                    </textarea>
                </mat-form-field>
            </div>
        </div>

    </div>
    <div mat-dialog-actions class="qualificates-theme">
        <div fxFlex></div>
        <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
        <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
    </div>

</form>